<template>
  <div class="h-100">
    <header-simple />

    <v-row class="h-100">
      <landing-column />

      <v-col cols="12" md="4" sm="6" order-sm="1" class="d-flex align-start justify-center login-form-row">
        <div class="form--maxsize">
          <password title="Zmiana hasła" text="Podaj nowe hasło" @change="changePassword" />
        </div>
      </v-col>
    </v-row>
    <material-dialog
      confirm-text="Ok"
      :title="title"
      :text="text"
      :show="showDialog"
      :show-cancel="false"
      :width="500"
      @confirm="closeNotificationDialog"
    />
  </div>
</template>

<script>
import { authResource } from '@witkac/kartamiejska-resources';

import LandingColumn from '@/components/layout/LandingColumn';
import HeaderSimple from '@/components/layout/HeaderSimple';
import password from '@/components/material/Password';
import materialDialog from '@/components/material/Dialog';

// @vuese
// Widok potwierdzenia konta
// @group Account
export default {
  components: {
    password,
    materialDialog,
    HeaderSimple,
    LandingColumn
  },
  data() {
    return {
      showDialog: false,
      title: '',
      text: '',
      validation: undefined
    };
  },
  methods: {
    // @vuese
    // Funkcja potwierdzająca konto
    changePassword(password) {
      authResource
        .setPassword(this.$route.params.token, password)
        .then(() => {
          this.showDialog = true;
          this.validation = true;
          this.title = 'Gratulacje';
          this.text = 'Twoje hasło zostało zmienione.';
        })
        .catch(() => {
          this.showDialog = true;
          this.validation = false;
          this.title = 'Niestety';
          this.text = 'Nie udało się zmienić hasła. Sprawdź, czy użyty link jest poprawny.';
        });
    },
    // @vuese
    // Funkcja zamykająca notyfikację lub przenosząca na strone logowania
    closeNotificationDialog() {
      if (this.validation) {
        this.$router.push({ name: 'login' });
      } else {
        this.showDialog = false;
      }
    }
  }
};
</script>
